module.exports = __webpack_public_path__ + "img/salesplan.b661d08a.png";